import { generateClient } from 'aws-amplify/api';
import { listChangelog, listChangelogByUser, listChangelogByCustomer } from '../graphql/queries';

const client = generateClient({
  authMode: 'userPool'
});

class ChangelogService {
  /**
   * List all changelog entries (chronologically)
   * @param {number} limit - Maximum number of entries to return
   * @param {string} nextToken - Pagination token
   * @returns {Promise} Changelog entries with pagination
   */
  async listChangelog({ limit = 50, nextToken = null }) {
    try {
      const result = await client.graphql({
        query: listChangelog,
        variables: { limit, nextToken }
      });
      return result;
    } catch (error) {
      console.error('Error listing changelog:', error);
      throw error;
    }
  }

  /**
   * List changelog entries for a specific user
   * @param {string} userId - User email
   * @param {number} limit - Maximum number of entries to return
   * @param {string} nextToken - Pagination token
   * @returns {Promise} Changelog entries with pagination
   */
  async listChangelogByUser({ userId, limit = 50, nextToken = null }) {
    try {
      const result = await client.graphql({
        query: listChangelogByUser,
        variables: { userId, limit, nextToken }
      });
      return result;
    } catch (error) {
      console.error('Error listing changelog by user:', error);
      throw error;
    }
  }

  /**
   * List changelog entries for a specific customer
   * @param {string} customerId - Customer ID
   * @param {number} limit - Maximum number of entries to return
   * @param {string} nextToken - Pagination token
   * @returns {Promise} Changelog entries with pagination
   */
  async listChangelogByCustomer({ customerId, limit = 50, nextToken = null }) {
    try {
      const result = await client.graphql({
        query: listChangelogByCustomer,
        variables: { customerId, limit, nextToken }
      });
      return result;
    } catch (error) {
      console.error('Error listing changelog by customer:', error);
      throw error;
    }
  }
}

export default ChangelogService;
